/**
 * Class that have the hability to work as an interface to make possible to
 * save classes as a json doc on an external data base, for example firestore.
 * This class offers method to convert the class information into a JSON doc (Map) and also
 * to retrieve a JSON and build the class information from thtat file.
 *  */
export class JsonDoc {
  private _docId: string | null;

  /**
   * Constructor
   * @param docId Opcional parameter to construct the class with the document id from the beginning
   */
  constructor(docId?: string) {
    if (docId) this._docId = docId;
  }

  /**
   * Gets the document ID
   * @returns The string of the ID or null if the id is not setted yet
   */
  public get docId(): string | null {
    return this._docId;
  }

  /**
   * Sets the documento ID
   */
  public set docId(docId: string | null) {
    this._docId = docId;
  }

  /**
   * Transforms the current class into an JSON Map that can be easely store on an external
   * data base.
   * @returns A Map object [string,string] representing all the key atributes of the class and their value.
   */
  public toJson(): Map<string, string> {
    var map = new Map<string, string>([]);
    for (let key in this) {
      map[key.toString()] = JSON.stringify(this[key] as string);
    }
    return map;
  }

  /**
   * Updates the class with the given data from a given JSON
   * @param data The data to take and update the attributes
   */
  public parseJson(data: any) {
    //var map = JSON.parse(data);
    data.forEach((value: any, key: string) => {
      this[key] = JSON.parse(value);
    });
  }
}
